import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";
import { Icon, IconBox } from "@proda-ai/ui-kit";
import MessageWithButton, {
    type MessageWithButtonProps,
} from "../MessageWithButton";
import { isTruthy } from "@/utils/guards";

export type EmptyGridMessageRendererProps = BoxProps &
    Partial<MessageWithButtonProps> & {
        gridError?: boolean;
        searchPhrase?: string | null;
        errorMessage?: string;
        emptyMessage?: string;
        emptySubMessage?: string;
    };

const testId = "EmptyGridMessageRenderer";
const EmptyGridMessageRenderer = (props: EmptyGridMessageRendererProps) => {
    const {
        sx,
        gridError,
        searchPhrase,
        errorMessage,
        emptyMessage,
        emptySubMessage,
        ...messageWithButtonProps
    } = props;
    return (
        <Box
            data-testid={testId}
            sx={{
                ...sx,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                pointerEvents: "auto",
            }}
        >
            {isTruthy(gridError) ? (
                <MessageWithButton
                    {...messageWithButtonProps}
                    aria-disabled="false"
                    variant="error"
                    message={errorMessage}
                    buttonLabel="Refresh Page"
                    buttonAction={() => window.location.reload()}
                />
            ) : (
                <>
                    <IconBox mb={4}>
                        <Icon
                            icon="folder-open"
                            color="var(--proda-black)"
                            size={70}
                        />
                    </IconBox>
                    <Typography
                        variant="h1"
                        sx={{
                            marginBottom: "1rem",
                        }}
                    >
                        {emptyMessage}
                    </Typography>
                    <Typography variant="body1">
                        {emptySubMessage}
                        {isTruthy(searchPhrase) && searchPhrase.length > 0
                            ? ` for query "${searchPhrase}".`
                            : "."}
                    </Typography>
                </>
            )}
        </Box>
    );
};

export default EmptyGridMessageRenderer;
